import PropTypes from 'prop-types'
import { gql } from '@apollo/client'

export const artistFragment = gql`
  fragment artist on Artist {
    id
    name
    slug
    avatar
    numberOfUpcomingEvents
    isFollowedByViewer
  }
`

export const artistFragmentPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  numberOfUpcomingEvents: PropTypes.number.isRequired,
  isFollowedByViewer: PropTypes.bool.isRequired,
})
